import { useTranslation } from 'react-i18next';
import { Card, Input } from '../common';
import { usePricingStore } from '../../stores/pricingStore';

interface SidebarProps {
  fcrTable: [number, number][];
  className?: string;
}

export function Sidebar({ fcrTable, className = '' }: SidebarProps) {
  const { t } = useTranslation();
  const { manualTargetFCR, setManualTargetFCR } = usePricingStore();

  const handleManualFCRChange = (value: string) => {
    const numValue = parseFloat(value);
    if (value === '' || isNaN(numValue)) {
      setManualTargetFCR(null);
    } else {
      setManualTargetFCR(numValue);
    }
  };

  return (
    <aside className={`space-y-4 ${className}`}>
      {/* Manual FCR Override */}
      <Card title={t('sidebar.manualFCRTitle')}>
        <Input
          label={t('sidebar.manualFCRLabel')}
          type="number"
          step="0.001"
          value={manualTargetFCR?.toString() ?? ''}
          onChange={(e) => handleManualFCRChange(e.target.value)}
          helperText={t('sidebar.manualFCRHelper')}
          placeholder={t('sidebar.manualFCRPlaceholder')}
        />
      </Card>

      {/* FCR Scale Table */}
      <Card title={t('sidebar.fcrTableTitle')} padding="sm">
        <div className="max-h-96 overflow-y-auto">
          <table className="w-full text-sm">
            <thead className="sticky top-0 bg-gray-50 dark:bg-gray-700">
              <tr>
                <th className="px-2 py-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300">
                  {t('sidebar.weight')}
                </th>
                <th className="px-2 py-2 text-left text-xs font-medium text-gray-700 dark:text-gray-300">
                  {t('sidebar.targetFCR')}
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 dark:divide-gray-600">
              {fcrTable.map(([weight, fcr], index) => (
                <tr
                  key={`fcr-${weight}-${index}`}
                  className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
                >
                  <td className="px-2 py-1.5 text-gray-900 dark:text-gray-100">
                    {weight.toFixed(3)}
                  </td>
                  <td className="px-2 py-1.5 text-gray-900 dark:text-gray-100">
                    {fcr.toFixed(3)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </aside>
  );
}
